import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button } from '@bwoty-web/styleguide';

import styles from './SearchPanelHeader.scss';

export const SearchOptions = {
  departure: 'departure',
  dateFrom: 'dateFrom',
  dateTo: 'dateTo',
  tripLength: 'tripLength',
};

export function SearchPanelHeader(props) {
  const { children, buttonLabel, onClick, isLoading, isHidden } = props;

  const c = classnames(styles.root, {
    [styles.isHidden]: isHidden,
  });

  return (
    <div className={c}>
      <div className={styles.text}>{children}</div>
      <div className={styles.button}>
        <Button
          theme="secondary"
          onClick={onClick}
          loading={isLoading}
          disabled={isLoading}
          data-test="lms-open-search"
        >
          {buttonLabel}
        </Button>
      </div>
    </div>
  );
}

SearchPanelHeader.propTypes = {
  children: PropTypes.node,
  buttonLabel: PropTypes.node,
  onClick: PropTypes.func,
  isLoading: PropTypes.bool,
  isHidden: PropTypes.bool,
};
